




































import Vue from 'vue'
import Component from 'vue-class-component'
import ModalV2 from '@/components/modals/ModalV2.vue'

@Component({
  props: {
    header: {
      type: String,
      required: true
    },
    subHeader: {
      type: String,
      required: false
    },
    submessage: {
      type: String
    },
    message: {
      type: String,
      required: true
    },
    content: {
      type: String
    },
    okButtonLabel: {
      type: String,
      default: 'OK'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    outerClose: {
      type: Boolean,
      default: true
    }
  },
  components: {
    ModalV2
  }
})
export default class Confirm extends Vue {

}
